import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "react-js-pagination";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";
import { formatDate } from "../../utils/utils";


const Videogallery = () => {
    const [fatchdata, setFatchdata] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items to display per page
    const [filteredData, setfilteredData] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = async () => {
        try {
            const response = await thirdparty.get("/videogallery/get");

            console.log("respoinse", response);

            if (response.status === 200) {
                setFatchdata(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };


    const handleDelete = async (id) => {
        try {
            let confirmation = confirm("Are you sure to delete this item?");
            if (!confirmation) {
                return;
            }
            const response = await thirdparty.delete(`/videogallery/delete/${id}`); // Update the API endpoint
            if (response.status === 200) {
                toast.success("Deleted Successfully!", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                console.log(`Item with ID ${id} deleted successfully.`);
                fetchData(); // Fetch updated data after deletion
            }
        } catch (error) {
            console.error(`Error deleting item with ID ${id}:`, error.message);
        }
    }


    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Initial data fetch
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const filteredData =
            fatchdata &&
            fatchdata.filter((item) =>
                Object.values(item).some((value) =>
                    value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                )
            );

        setfilteredData(filteredData);
    }, [fatchdata, searchTerm]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData
        ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
        : [];

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    return (
        <div className="fixed-left">
            <div id="wrapper">
                <Route component={LeftSidebar} />
                <div className="content-page">
                    <div className="content">
                        <Route component={TopHeader} />
                        <div className="row page-content-wrapper">
                            <div className="card p-0">
                                <div className="card-header row">
                                    <div className="col-md-8">
                                        <h5 className="card-title text-left">Video Gallery</h5>

                                    </div>
                                    <div className="col-md-4 text-right">
                                        <input
                                            className="form-control"
                                            type="search"
                                            placeholder="Search"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Time</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.length > 0 ? currentItems.map((item) => (
                                                <tr key={item.id}>
                                                    <th>{item.id}</th>
                                                    <td>{item.video_gallery_name}</td>
                                                    <td>{item.video_gallery_desc}</td>
                                                    <td>{formatDate(item.created_at)}</td>
                                                    <td>
                                                        <a href={"/editVideoGallery/" + item.id} ><i className="fa fa-pencil-square display-4"></i></a>
                                                        <a href={"/editVideoGallery/" + item.id}><i className="fa fa-eye mx-2 display-4"></i></a>
                                                        <a onClick={() => handleDelete(item.id)}><i className="fa fa-trash display-4" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete Request"></i></a>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="100%" className="text-center">No data found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        activePage={currentPage}
                                        itemsCountPerPage={itemsPerPage}
                                        totalItemsCount={
                                            filteredData ? filteredData.length : 1
                                        }
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
    );

};



export default Videogallery;


// WEBPACK FOOTER //
// ./src/component/admin/videogallery.js